import {
  transcriptionRetryResultSchema,
  transcriptionRetrySchema,
} from "@rosc/contracts";
import { referenceClient } from "@/lib/orpc/client";

export const createTranscription = async (
  id: string,
  body: unknown,
  identity: { key: string; userUid: string; signal?: AbortSignal },
) => {
  const parsed = transcriptionRetrySchema.parse(body);
  const response = await referenceClient.createTranscription(
    {
      params: { public_id: String(id) },
      body: parsed,
      headers: { "idempotency-key": identity.key },
    },
    { context: { expectedUserUid: identity.userUid }, signal: identity.signal },
  );
  const result = transcriptionRetryResultSchema.parse(response);
  if (result.public_id !== id)
    throw Error("Transcription response does not match this visit");
  return result;
};
